import { TagBid } from './TagBid.js';

/**
 * Full response from the adtag endpoint.
 * Mirrors Rust AdTagResponse.
 *
 * Returned for both HTTP 200 JSON envelopes and synthetic empty responses
 * created by the client for HTTP 204 no-fill outcomes.
 */
export class AdTagResponse {
  /** @param {Record<string, unknown>} raw */
  constructor(raw) {
    this._syncFrameUrl = raw.sync_frame_url ?? null;
    this._bid          = raw.bid ? new TagBid(raw.bid) : null;
    this._privacy      = raw.privacy ?? null;
  }

  /**
   * URL to fire as a hidden iframe for demand-side cookie syncing.
   * Null when consent signals block sync, or when no sync domain is configured.
   * Should be fired on every response regardless of fill outcome.
   * @returns {string | null}
   */
  get syncFrameUrl() { return this._syncFrameUrl; }

  /**
   * The winning bid, or null on no-fill.
   * @returns {TagBid | null}
   */
  get bid() { return this._bid; }

  /** Server-tightened privacy capabilities, absent on legacy/204 responses. */
  get privacy() { return this._privacy; }

  /**
   * Whether a bid was won and creative content is available to render.
   * @returns {boolean}
   */
  hasBid() { return this._bid !== null; }
}
